export default "__VITE_ASSET__boM1E_Gp__"